'use client'

import { type FC, type ReactNode } from 'react'
import { FormattedMessage } from 'react-intl'

import { IconCopy } from '@redteclab/icons'

import { Button, Dialog, DialogContent, DialogTitle, Input } from 'base-ui'

import { useOpenableControls } from '../../../generic-hooks'

import { StoryblokVoucherCardButtonCopy } from './StoryblokVoucherCardButtonCopy'

type StoryblokVoucherCardConditionsButtonProps = {
  overlayContent: ReactNode
  overlayTitle: ReactNode
  promoCode?: string
}

export const StoryblokVoucherCardConditionsButton: FC<
  StoryblokVoucherCardConditionsButtonProps
> = ({ overlayContent, overlayTitle, promoCode }) => {
  const modalControls = useOpenableControls()

  return (
    <>
      <Button
        className="w-full tablet:w-auto"
        color="secondary"
        onClick={modalControls.handleOpen}
        size="small"
      >
        <FormattedMessage id="voucherBox.label.conditions" />
      </Button>
      <Dialog onClose={modalControls.handleClose} open={modalControls.isOpen}>
        <DialogTitle onClose={modalControls.handleClose}>
          {overlayTitle}
        </DialogTitle>

        <DialogContent className="p-0">
          {promoCode ? (
            <div className="flex flex-col gap-2 bg-light-brand-medium p-6 tablet:flex-row tablet:gap-4">
              <Input className="w-full" disabled value={promoCode} />
              <StoryblokVoucherCardButtonCopy
                startIcon={<IconCopy color="white" />}
                textToCopy={promoCode}
              >
                <FormattedMessage id="voucherBox.input.shortLabel.button" />
              </StoryblokVoucherCardButtonCopy>
            </div>
          ) : null}
          <div className="flex flex-col gap-6 p-5">{overlayContent}</div>
        </DialogContent>
      </Dialog>
    </>
  )
}
